import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 13.223 8.45 16.7a1.05 1.05 0 0 0 1.707.051L18 6.828"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25.749h19.5s1.5 0 1.5 1.5v19.5s0 1.5-1.5 1.5H2.25s-1.5 0-1.5-1.5v-19.5s0-1.5 1.5-1.5"
    }, null, -1)
  ]));
}
const interfaceValidationCheckboxSquare = { render };
export {
  interfaceValidationCheckboxSquare as default,
  render
};
//# sourceMappingURL=interface-validation-checkbox-square.svg.js.map
